import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const routeTitles = {
  '/': 'Home - SOFTORA Technologies',
  '/about': 'About - SOFTORA Technologies',
  '/services': 'Services - SOFTORA Technologies',
  '/technologies': 'Technologies - SOFTORA Technologies',
  '/contact': 'Contact - SOFTORA Technologies',
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      window.scrollTo(0, 0);
    } catch (e) {
      // safe fallback
    }

    const pageTitle = routeTitles[pathname.toLowerCase()] || 'SOFTORA Technologies';
    document.title = pageTitle;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
